<template>
  <div class="help-center">
    <user-section></user-section>
    <!-- <img class="head-banner-bg" src="../../assets/img/head-banner-bg.jpg"> -->
    <!-- 服务进度 -->
    <order-service-section zz-sectionid="1"></order-service-section>
    <!-- 推荐阅读 -->
    <common-question zz-sectionid="2"></common-question>
    <!-- 咨询分类 -->
    <question-category zz-sectionid="3"></question-category>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import QuestionCategory from './QuestionCategory/QuestionCategoryWA'
import CommonQuestion from './CommonQuestion/CommonQuestion'
import UserSection from './UserSection/UserSection'
import OrderServiceSection from './OrderServiceSection'

export default {
  name: 'HelpCenter',
  components: {
    CommonQuestion,
    QuestionCategory,
    UserSection,
    OrderServiceSection
  },
  created() {
    native.setTitle({
      title: '客服中心'
    })
    lego.send({
      pagetype: 'ZZUP_HELPCENTER_WA',
      actiontype: 'PAGE_SHOW'
    })
  }
}
</script>

<style lang="less" scoped>
  @import 'HelpCenter.less';
</style>
